import React from "react";

const mentionsRegex = /\[user=\d+]([^[]+)\[\/user]/gm;

const WithMentions = ({ text }) => {
    const matchData = [];
    let match;
    while ((match = mentionsRegex.exec(text)) !== null) {
        matchData.push(match);
    }
    if (matchData.length === 0) {
        return text;
    }

    return matchData.reduce((acc, item, index) => {
        const prevItemEndedAt = index === 0 ? 0 : matchData[index - 1].index + matchData[index - 1][0].length;
        if (prevItemEndedAt < item.index) {
            acc.push(<span key={`prev_item_${index}`}>{text.substring(prevItemEndedAt, item.index)}</span>);
        }

        acc.push(
            <span key={`mention_${index}`} className="chat-msg__mention">
                {item[1]}
            </span>,
        );

        if (index === matchData.length - 1 && text.length > item.index + item[0].length) {
            acc.push(<span key={index}>{text.substring(item.index + item[0].length)}</span>);
        }
        return acc;
    }, []);
};

export default WithMentions;
